import React from 'react';

import {EmptyEnum} from 'main/analytics/gaTagsEnum';
import {ContentState} from 'presentation/components';
import {StyledContainer} from './styles';
import {EmptyStateProps} from './types';

export function EmptyState({
	title,
	description,
	customIconName = 'image-not-supported-filled',
}: EmptyStateProps) {
	return (
		<StyledContainer data-tag-id={EmptyEnum.EMPTY_STATE}>
			<ContentState title={title} description={description} customIconName={customIconName} />
		</StyledContainer>
	);
}
